// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"201":"c1295dc1","596":"e59647de","673":"587144e4","782":"a0051ea4","866":"860b3c66","956":"2b167927","986":"04fcaef9"}[chunkId] + ".css";
};